import React from 'react'
import DeleteIcon from '../../../icons/DeleteIcon'

export const createDeleteDayModal = (day, onCloseModal, handleDeleteDay) => ({
  isOpen: true,
  title: 'Delete Date?',
  description: (
    <span>
      Are you sure you want to delete this date:
      <br /> <strong>{day.date}</strong>? This action cannot be undone.
    </span>
  ),
  buttons: [
    {
      label: 'Cancel',
      outlined: false,
      onClick: onCloseModal,
    },
    { label: 'Delete', onClick: () => handleDeleteDay(day) },
  ],
  onClose: onCloseModal,
  icon: <DeleteIcon />,
})
